import { RequireSubmissionProvided } from "../../../../../wrappers/requireSubmission";
import { useEffect, useMemo } from "react";
import { SubmissionData2026SMI, SubmissionData2026SMIAddon, isSubmissionData2026, updateSubmission } from "../../../../../reduxToolkit/submissionsSlice";
import { useAppDispatch } from "../../../../../hooks/reduxToolkit";
import { SubmissionInstructionsSmi2026 } from "./submissionInstructionsSmi2026";

export interface SubmitToSmi2026Props extends RequireSubmissionProvided {
}

export function SubmitToSmi2026({ submission }: SubmitToSmi2026Props) {
  const dispatch = useAppDispatch()
  const isAddon = submission.submission_type === 'SMI-addon'

  const data = useMemo((): SubmissionData2026SMI | SubmissionData2026SMIAddon => {
    if (isSubmissionData2026(submission.data) && (submission.data.type === 'SMI' || submission.data.type === 'SMI-addon')) {
      return submission.data
    }

    return {
      _version: '2026-01-01',
      type: isAddon ? 'SMI-addon' : 'SMI',
      instructionsShown: true,
    }
  }, [submission.data, isAddon])

  useEffect(() => {
    if (!submission.data || !isSubmissionData2026(submission.data)) {
      dispatch(updateSubmission({
        id: submission.id,
        updated_at: new Date().toISOString(),
        data,
      }))
    }
  }, [dispatch, submission.id, submission.data, data])

  return <SubmissionInstructionsSmi2026 submission={submission} data={data} />
}
